import { isEqual } from 'Utils/lodashUtils';
import * as types from '../actions/actionTypes';
import initialState from './initialState';
import { getLowestSelectedOrgs } from '../selectors/dataAccessSelectors';

export default function globalFilterReducer(state = initialState.globalFilter, action) {
  switch (action.type) {
    case types.UPDATE_GLOBAL_FILTER:
      return Object.assign(
        {},
        state,
        { selectedMerchants: action.merchantCount },
        { filters: [...action.filters] },
        { orgIds: action.orgIds },
        { lowestLevelSelected: action.lowestLevelSelected },
      );

    case types.UPDATE_SCHEDULE_GLOBAL_FILTER:
      return Object.assign(
        {},
        state,
        { scheduleSelectedMerchants: action.merchantCount },
        { scheduleFilters: [...action.filters] },
        { scheduleOrgIds: action.orgIds },
        { scheduleMerchantList: [...action.merchantList] },
      );

    case types.ADD_TO_GLOBAL_FILTER:
      return Object.assign(
        {},
        state,
        { selectedMerchants: action.merchantCount },
        { filters: [...state.filters, action.branch] },
        { orgIds: state.orgIds.concat(getLowestSelectedOrgs(action.branch.currentRow, action.merchantIndex)) }, // eslint-disable-line comma-dangle
      );

    case types.ADD_TO_GLOBAL_FILTER_ORG_IDS:
      return Object.assign({}, state, { orgIds: action.orgIds });

    case types.ADD_SUPPORT_REQUEST_ORGID_TO_GLOBAL_ORG_IDS:
      return Object.assign({}, state, { supportOrgIds: action.orgIds });

    case types.CLEAR_SUPPORT_REQUEST_GLOBAL_FILTER:
      return Object.assign({}, state, { supportOrgIds: null });

    case types.REMOVE_FROM_GLOBAL_FILTER:
      return state.filter((branch) => {
        return !isEqual(branch, action.branch);
      });

    case types.CLEAR_GLOBAL_FILTER:
      return initialState.globalFilter;

    case types.REQUEST_USER_ORGANIZATIONS:
      return {
        ...state,
        isFetching: true,
        error: null,
      };

    case types.RECEIVE_USER_ORGANIZATIONS_SUCCESS: {
      const receivedOrganizations = [...action.userOrganizations];
      const userOrganizations = state.userOrganizations ? [...state.userOrganizations] : receivedOrganizations;

      // if this is a child list of organizations, and not the initial top level list, attach the child list of organizations to it's parent in the hierarchy
      if (state.userOrganizations) {
        const findItem = (arr, itemId) =>
          arr.reduce((a, item) => {
            if (a) return a;
            if (item.id === itemId) return item;
            if (item.organizations) return findItem(item.organizations, itemId);
          }, null);
        const parentOrg = findItem(userOrganizations, action.orgId);
        if (parentOrg) {
          parentOrg.organizations = receivedOrganizations;
        }
      }

      return {
        ...state,
        isFetching: false,
        userOrganizations,
        lastUpdated: action.receivedAt,
        error: null,
      };
    }

    default:
      return state;
  }
}
